// extracted by mini-css-extract-plugin
module.exports =  {"pagination-section":"_93444fe79c--pagination-section--DBmk6","pagination":"_93444fe79c--pagination--UX22n","buttons":"_93444fe79c--buttons--mnhdJ"};